import { connect } from 'react-redux';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { ProductList } from 'src/components/organisms/ProductList/components/ProductList/ProductList';
import { productListClick } from 'src/components/organisms/ProductList/modules/actions';
import { selectReferredBy } from 'src/components/organisms/ProductList/modules/selectors';
import type {
  ProductListContainerDispatchProps,
  ProductListContainerOwnProps,
  ProductListContainerStateProps,
} from 'src/components/organisms/ProductList/types';
import { ProductCardDiscountAmount } from 'src/featureFlags/featureFlags';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProviderAttributionToken } from 'src/redux/products/selectors/selectors';
import type { UpdateHistoryPayload } from 'src/redux/products/thunks/updatePageHistory';
import { updatePageHistory } from 'src/redux/products/thunks/updatePageHistory';
import type { AppThunkDispatch } from 'src/redux/store';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking/slice';
import type { NextConfig } from 'src/types/nextConfig';

const nextConfig = getConfig() as NextConfig;

export const mapStateToProps = (
  state: ReduxApplicationState,
  ownProps: ProductListContainerOwnProps,
): ProductListContainerStateProps => {
  return {
    currency: state.user.currencyCode,
    inListingsCallout: (ownProps.page === 1 && state.content.inListingsCallout) || undefined,
    referredBy: selectReferredBy(state),
    providerAttributionToken: selectProviderAttributionToken(state),
    showSavingAmount:
      state.user.featureFlags?.[ProductCardDiscountAmount.NAME] === ProductCardDiscountAmount.SHOWN,
  };
};

export const mapDispatchToProps = (
  dispatch: AppThunkDispatch,
): ProductListContainerDispatchProps => {
  return {
    updateFavourite: ({ productCode }: { productCode: number }) =>
      dispatch(updateFavourite({ productCode, nextConfig })),
    updatePageHistory: (payload: UpdateHistoryPayload) => dispatch(updatePageHistory(payload)),
    onInListingsCalloutClick: (ev: React.MouseEvent<HTMLAnchorElement>) => {
      const url = new URL(ev.currentTarget.href);

      sendGALinkClickEvent(ev, {
        event: 'custom_event',
        event_action: 'CTA click',
        event_name: 'select_content',
        event_details: 'cta click',
        content_type: `in-listings callout|${url.pathname}`,
      });
    },
    onProductVisible: ({ productCode }: { productCode: number }) =>
      dispatch(visibilityTrackingActions.onProductVisible({ productCode })),
    onProductClick: ({
      destinationUrl,
      linkOpensInSameWindow,
      productCode,
      productUrl,
    }: {
      destinationUrl: string;
      linkOpensInSameWindow: boolean;
      productCode: number;
      productUrl: string;
    }) => {
      dispatch(visibilityTrackingActions.sendProductImpressionBatch());
      dispatch(
        productListClick({ productUrl, destinationUrl, productCode, linkOpensInSameWindow }),
      );
    },
  };
};

export const ProductListContainer = connect(mapStateToProps, mapDispatchToProps)(ProductList);
